import { Component } from '@angular/core';
import { first } from 'rxjs/operators';

import { User } from '@app/_models';
import { UserService, AuthenticationService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { Router } from '@angular/router';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {
    loading1 = false;
    loading2 = false;
    loading3 = false;

    userData: any;
    coursesProgress: any[];
    journeySteps: any[];

    constructor(private router: Router, private courseService: CourseService) { }

    ngOnInit() {
        this.loading1 = true;
        this.courseService.getDashboard().pipe(first()).subscribe(userData => {
            this.loading1 = false;
            this.userData = userData;
        });

        this.loading2 = true;
        this.courseService.getJourney().pipe(first()).subscribe(journeySteps => {
            this.loading2 = false;
            this.journeySteps = journeySteps;
        });

        this.loading3 = true;
        this.courseService.getCoursesProgress().pipe(first()).subscribe(coursesProgress => {
            this.loading3 = false;
            this.coursesProgress = coursesProgress;
        });
    }

    getContinuationLink(courseProgress) {

        if (courseProgress.hasPrecourse && !courseProgress.userHasPrecourseEvent) {
            // user needs to do a precourse first
            return [`/${courseProgress.preCourseComponent}`, courseProgress.sectionId.toString()];
        }

        return ['/course-section', courseProgress.sectionId.toString()];
    }

    getQueryParams(courseProgress) {
        return { isIntro: courseProgress.isIntro };
    }
}